module.exports = __webpack_public_path__ + "static/media/Maple-Hill-HOA-By-Laws.cac2cc42.pdf";